/**
 * @generated SignedSource<<f9370d96d89dc8d42e277b3190f15965>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SessionStartQuery$variables = Record<PropertyKey, never>;
export type SessionStartQuery$data = {
  readonly me: {
    readonly learner: {
      readonly defaultCharacter: {
        readonly accentHex: string;
        readonly artKey: string;
        readonly displayName: string;
        readonly id: string;
        readonly intensity: number;
      } | null | undefined;
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type SessionStartQuery = {
  response: SessionStartQuery$data;
  variables: SessionStartQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Account",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Learner",
        "kind": "LinkedField",
        "name": "learner",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Character",
            "kind": "LinkedField",
            "name": "defaultCharacter",
            "plural": false,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "artKey",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accentHex",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "intensity",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SessionStartQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SessionStartQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "170d52770f932e0832c05ee3761f13e8",
    "id": null,
    "metadata": {},
    "name": "SessionStartQuery",
    "operationKind": "query",
    "text": "query SessionStartQuery {\n  me {\n    learner {\n      id\n      defaultCharacter {\n        id\n        displayName\n        artKey\n        accentHex\n        intensity\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "81e8135d2c18b1fa68e1aeccd1096391";

export default node;
